import React from "react";
import { Image } from "react-bootstrap";
import ImageFoodGroup from "../toolboxComponents/foodGroupComponent/ImageFoodGroup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarker } from "@fortawesome/free-solid-svg-icons";
import { getfooditemsbyfoodgroupID } from "../../api/Api";
import * as allergensIcons from "../../styles/allergens";

class FoodGroup_Port extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      type_size: this.props.item.typeSize,
      foodgroup: [],
    };
  }
  componentDidMount() {
         // this.setstate({ switchDiamondbackground: false });
         if (this.props.item.switchDiamondbackground === undefined)
          {
         this.props.item.switchDiamondbackground=false;
        }
        if (this.props.item.switchSplitStyle === undefined)
          {
          this.props.item.switchSplitStyle = false;
        //  this.setState({ switchSplitStyle: false });
          }
    this.getFoodItems();
    this.interval = setInterval(this.getFoodItems.bind(this), 180 * 10000);
  }
  componentWillUnmount() {
    // Clear the interval right before component unmount
    clearInterval(this.interval);
  }

  //get MAP FROM DISPLAY ID
  getFoodItems = () => {
    getfooditemsbyfoodgroupID(this.props.item.id).then((res) => {
      if (res == null) {
        this.setState({ foodgroup: [] });
      } else if (res[0]) {
        this.setState({ foodgroup: res });
      } else {
        this.setState({ foodgroup: [] });
      }
    });
  };

  //get Icon Allergens
  getIconSvg(allergen) {
    let allergenIcon = allergen
      .split(" ")
      .join("")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
    if (allergen) {
      const svgIndex = "Svg" + allergenIcon;
      return allergensIcons[svgIndex];
    }
    return null;
  }

  //get WIDTH FLEX
  getwidthItems() {
    let activeFoodItem = this.state.foodgroup.filter(function (value) {
      return value.active !== false;
    }).length;
    let flex = " 33%";
    if (this.state.switchDiamondbackground === true) {
      flex = " 95%";
    
    } else {
       flex = " 25%";
       if (this.state.type_size === 1) {
          if (activeFoodItem > 6) {
           flex = " 20%";
         } else if (activeFoodItem <= 4) {
        flex = " 40%";
         } else if (activeFoodItem <= 6) {
        flex = " 30%";
          }
    } else if (this.state.type_size === 2) {
      if (activeFoodItem > 2) {
        flex = " 40%";
      } else if (activeFoodItem <= 2) {
        flex = " 55%";
      }
    } else if (this.state.type_size === 3) {
      flex = " 95%";
    } else if (this.state.type_size === 4) {
      flex = " 40%";
    } else if (this.state.type_size === 5) {
      flex = " 10%";
    }
  }
    /*let flex = " 33%";
    if (this.props.item.switchDiamondbackground === true) {
      flex = " 95%";
    
    } else {
      flex = " 25%";
    if (this.state.type_size == 1) {
      if (activeFoodItem > 4) {
        flex = " 30%";
      } else if (activeFoodItem <= 4) {
        flex = " 47%";
      }
    } else if (this.state.type_size == 2) {
      flex = " 44%";
    } else if (this.state.type_size == 3) {
      flex = " 44%";
    } else if (this.state.type_size == 4) {
      flex = " 43%";
    }
    
  }*/
  return flex;
  }

  //get max number of Food item
  getmaxFoodItem() {
    let slice = 8;
    if (this.props.item.switchDiamondbackground === true) {
      if (this.state.type_size === 1) {
        slice = 8;
      } else if (this.state.type_size === 2) {
        slice = 5;
      } else if (this.state.type_size === 3) {
        slice = 5;
      } else if (this.state.type_size === 4) {
        slice = 5;
      } else if (this.state.type_size === 5) {
        slice = 5;
      } 
  }
  else 
  {
    if (this.state.type_size === 1) {
      slice = 8;
    } else if (this.state.type_size === 2) {
      slice = 4;
    } else if (this.state.type_size === 3) {
      slice = 2;
    } else if (this.state.type_size === 4) {
      slice = 2;
    } else if (this.state.type_size === 5) {
      slice = 4;
    }
  }
    return slice;
  }
  //Capitalize
  capitalize(s) {
    if (typeof s !== "string") return "";
    return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
  }
  getHeightItems() {
    let activeFoodItem =
      this.state.foodgroup.filter(function (value) {
        return value.active !== false;
      }).length;
     
      let heightItems = "400px";
    if (this.props.item.switchDiamondbackground === true) {
        
        switch (activeFoodItem) {
          case 1:
            heightItems = "95%";
            break;
          case 2:
            heightItems = "47.5%";
            break;
          case 3:
            heightItems = "47.5%";
            break;
          default:
           heightItems = "400px";
        }

      } else {
           if (this.state.type_size === 1 && activeFoodItem <= 2) {
            heightItems="85%"
           }
           else { heightItems ="400px" }
      }
      
      return heightItems
  }
  borderRadiusContainer() {
    if (this.props.item.borderRadius===undefined)
      {
        this.props.item.borderRadius=0
       }
      let borderRadiusContainer = this.props.item.borderRadius
        return borderRadiusContainer;
      
  }
  GetPriceAdjustment(PriceValue,CurrencyValue) {
    //alert(this.state.Curved_tb);
    if (CurrencyValue === " " ||
      CurrencyValue === "" ||
      CurrencyValue === "EUR" ||
      CurrencyValue === "Eur" ||
      CurrencyValue === "eur" ||
      CurrencyValue === "Euro")
      {
        PriceValue= Number(Math.round(parseFloat(PriceValue + 'e' + 2)) + 'e-' + 2).toFixed(2)
      }
   // if (this.props.item.switchDiamondbackground === true && PriceValue < 10)
  //  {
   //   return " " + PriceValue;
  //   }
   //  else
   //  {return PriceValue;}
   return PriceValue;
       
  }
  getFontAdjustment(myfontsize) {
    let activeFoodItem = this.state.foodgroup.filter(function (value) {
      return value.active !== false;
    }).length;  
    let fontSize = myfontsize;
    if (this.props.item.switchDiamondbackground === true) {
      if (this.props.item.switchSplitStyle===true)
        {
          switch (activeFoodItem) {
            case 1:
              fontSize = myfontsize;
              
              break;
            case 2:
              fontSize = myfontsize;
            // heightItems = "40.0%";
              break;
            case 3:
              fontSize = myfontsize*0.77;
            // heightItems = "26.67%";
              break;
            case 4:
              fontSize = myfontsize*0.70;
              // heightItems = "20%";
                break;
            case 5:
              fontSize = myfontsize*0.60;
              // heightItems = "16%";
                break;
            default:
              fontSize = myfontsize*0.6;
          }
        }
      else
      {
        switch (activeFoodItem) {
          case 1:
            fontSize = myfontsize;
            
            break;
          case 2:
            fontSize = myfontsize;
          // heightItems = "40.0%";
            break;
          case 3:
            fontSize = myfontsize*0.85;
          // heightItems = "26.67%";
            break;
          case 4:
            fontSize = myfontsize*0.70;
            // heightItems = "20%";
              break;
          case 5:
            fontSize = myfontsize*0.60;
            // heightItems = "16%";
              break;
          default:
            fontSize = myfontsize;
        }
          
      }
    }
  
  
  //console.log("fontSize");
  //console.log(fontSize);
  return fontSize;
   }
   GetPricesStyle2(CurrencyValue) {
    //alert(this.state.Curved_tb);
   /* const styles = {

      AGR_h6:"pricesStyle_AGR_h6",
      nonAGR: "pricesStyle",
      AGR_h6_euro: "pricesStyle_AGR_h6_euro"
  };*/



   // console.log("GetPricesStyle");
    //console.log(this.props.item.switchDiamondbackground);  
   // console.log(CurrencyValue);
    if (this.props.item.switchDiamondbackground === true && CurrencyValue ==='Pts')
    {
      return  "1.1rem";//styles["AGR_h6"] || "default-style";
     }
     else
     {
     if(CurrencyValue === " " ||
      CurrencyValue === "" ||
      CurrencyValue === "EUR" ||
      CurrencyValue === "Eur" ||
      CurrencyValue === "eur" ||
      CurrencyValue === "Euro" )
     {
      //return    "3.1rem";//styles["nonAGR"] || "default-style";
      
      let FoodStyleCurrency =  this.getFontAdjustment(this.props.item.fontSizePrice)+ "px";//styles["AGR_h6"] || "default-style";
      if (this.props.item.switchDiamondbackground === true )
      {
        FoodStyleCurrency="3.1rem"
      }
      return    FoodStyleCurrency;//styles["nonAGR"] || "default-style";
     }else
     {
      return    "1.1rem";//styles["AGR_h6_euro"] || "default-style";
   
     }

    }
    
     return "";//(this.state.fontSize_price *0.33) + "px";
       
  }
  render() {
    const divStyle = {
      height: "100%",
      width: "100%",
      transition: "all 250ms ease",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      borderRadius:this.borderRadiusContainer() +"px",
    };
    const VerticaldivStyle = {
      margin: "0",
      borderright: "2px solid",
      borderrightColor: this.props.item.color,
      width: "0",
      height: "100%",
      float:"right",
    };
    const containerStyle = {
      padding: "10px",
      backgroundColor: this.props.item.background,
      height: "100%",
      width: "100%",
      display: "flex",
      flexWrap: "wrap",
      // placeContent: "space-evenly",
      // position:"absolute",
      borderRadius:this.borderRadiusContainer() +"px",
    };

    const foodItemStyle = {
      position: "relative",
      height: this.getHeightItems(),
      backgroundColor: "#FFFFFF",
      padding: "0",
      margin: "auto 30px",
      flex: "1 1" + this.getwidthItems(),
      borderRadius:this.borderRadiusContainer() +"px",
    };
    const foodItemImageStyle = {
      display: "flex",
      flex: "2",
      objectFit: "cover",
      width: " 100%",
      height: "0",
    };

    const originStyle = {
      lineHeight: "1.1",
      fontWeight: "bold",
      fontFamily: this.props.item.fontFamilySecondary,
      color: this.props.item.colorAccent,
      fontSize: this.props.item.fontSizeOrigin + "px",
      borderRadius:this.borderRadiusContainer() +"px",
    };
    const titleStyle = {
      overflowWrap: "anywhere",
      lineHeight: "1.1",
      fontWeight: "bold",
      fontFamily: this.props.item.fontFamily,
      color: this.props.item.colorPrimary,
      fontSize: this.props.item.fontSizeTitle + "px",
      borderRadius:this.borderRadiusContainer() +"px",
    };

    const titleNIStyle = {
      overflowWrap: "anywhere",
      lineHeight: "1.1",
      fontWeight: "bold",
      fontFamily: this.props.item.fontFamily,
      color: this.props.item.colorPrimary,
      fontSize: this.props.item.fontSizeTitleNi + "px",
      width: "75%",
    };
    const titleSecStyle = {
      overflowWrap: "anywhere",
      lineHeight: "1.1",
      fontWeight: "bold",
      fontFamily: this.props.item.fontFamily,
      color: this.props.item.colorPrimary,
      fontSize: this.props.item.fontSizeTitleSec + "px",
      width: "75%",
    };

    const titleSecNIStyle = {
      overflowWrap: "anywhere",
      lineHeight: "1.1",
      fontWeight: "bold",
      fontFamily: this.props.item.fontFamily,
      color: this.props.item.colorPrimary,
      fontSize: this.props.item.fontSizeTitleSecNi + "px",
    };

    const descriptionStyle = {
      overflowWrap: "anywhere",
      lineHeight: "1.1",
      fontFamily: this.props.item.fontFamily,
      color: this.props.item.colorPrimary,
      fontSize: this.props.item.fontSizeDescription + "px",
    };

    const descriptionNIStyle = {
      overflowWrap: "anywhere",
      lineHeight: "1.1",
      fontFamily: this.props.item.fontFamily,
      color: this.props.item.colorPrimary,
      fontSize: this.props.item.fontSizeDescriptionNI + "px",
    };

    const descriptionSecStyle = {
      overflowWrap: "anywhere",
      lineHeight: "1.1",
      fontFamily: this.props.item.fontFamily,
      color: this.props.item.colorPrimary,
      fontSize: this.props.item.fontSizeDescriptionSec + "px",
    };
    const descriptionSecNIStyle = {
      overflowWrap: "anywhere",
      lineHeight: "1.1",
      fontFamily: this.props.item.fontFamily,
      color: this.props.item.colorPrimary,
      fontSize: this.props.item.fontSizeDescriptionSecNi + "px",
    };
    const containerLabelStyle = {
      position: "relative",
      alignSelf: "flex-end",
      //width: " max-content",
      top: "-40px",
      right: "5px",
      display: "flex",
      width: "100%",
      justifyContent: "end",
      height: 0,
    };
    const tagImageStyle = {
      backgroundColor: "#F6F6F6",
      borderRadius: "100%",
      objectFit: "cover",
      width: "60px",
      height: "60px",
      float: "left",
      margin: "0 3px",
    };
    const tagImageStyle_AGR = {
      backgroundColor: "#F6F6F6",
      borderRadius: "100%",
      objectFit: "cover",
      width: "60px",
      height: "60px",
      float: "left",
      margin: "0px 3px",
      borderStyle:"solid",
      borderColor:"#9b223e",
      zIndex: "100",
    };  

    const bodyStyle = {
      flexDirection: "column",
      // flex: "1",
      display: "flex",
      position: "relative",
      width: "100%",
    };
    const bodyStyleNi = {
      flexDirection: "column",
      // flex: "1",
      display: "flex",
      position: "relative",
      width: "100%",
      height: "100%",
    };

    const overflowStyle = {
      //overflow: "hidden",
      display: "flex",
      flexDirection: "column",
      height: "100%",
      padding: "0 8px",
      width:"75%",
    };
    const allergyContStyle = {
      //display: "block",
      padding: "0 5px",
      display: "flex",
      flexWrap: "wrap",
      paddingLeft: 0,
    };
    const allergyIconStyle = {
      fill: this.props.item.colorAccent,
      textAlign: "center",
      width: "30px",
      margin: "3px 0",
    };

    const caloriesStyle = {
      marginBottom: "0",
      lineHeight: "1.1",
      color: this.props.item.colorAccent,
      fontSize: this.props.item.fontSizeCalories + "px",
      fontFamily: this.props.item.fontFamilySecondary,
    };

    const containerPricesStyle = {
      position: "absolute",
      bottom: "110px",
      right: "-20px",
      backgroundColor: this.props.item.colorPrice,
      maxWidth: "170px",
      border: "1px solid #fff",
      textAlign: "center",
      padding: "5px",
    };
    const containerPricesStyle_agr = {
      position: "absolute",
      bottom: "50px",
      right: "30px",
      backgroundColor: this.props.item.colorPrice,
      color: this.props.item.colorPriceTx,
      maxWidth: "100px",
      border: "1px solid #fff",
      textAlign: "center",
      padding: "25px",
      borderRadius:"42px",
     
    };
    const pricesStyle_AGR = {
      marginBottom: 0,
      MarginTop: "10px",
      padding: "5px",
      textAlign: "center",
      fontFamily: this.props.item.fontFamilyPrice,
      color: this.props.item.colorPriceTx,
      fontSize:this.getFontAdjustment(this.props.item.fontSizePrice) + "px",
      fontweight: "bold",
    };
    const pricesStyle_AGR_h6  = (currency) => ({
      marginBottom: 0,
      //MarginTop: "10px",
      //padding: "5px",
      textAlign: "center",
      fontFamily: this.props.item.fontFamilyPrice,
      color: this.props.item.colorPriceTx,
      fontSize: this.GetPricesStyle2(currency),//"1.1em",//this.state.fontSize_price + "px",
      //fontweight: "bold",
    });
    const pricesStyle = {
      marginBottom: 0,
      padding: "5px",
      textAlign: "center",
      fontFamily: this.props.item.fontFamilyPrice,
      color: this.props.item.colorPriceTx,
      fontSize: this.props.item.fontSizePrice + "px",
    };
    const containerfoodItemStyle = {
      height: "100%",
      minHeight: "100%",
      display: "flex",
      flexDirection: "column",
    };
    return (
      <>
        <div style={divStyle}>
          <div style={containerStyle}>
            {this.state.foodgroup[0] &&
              this.state.foodgroup
                .filter(function (value) {
                  return value.active !== false;
                })
                .slice(0, this.getmaxFoodItem())
                .map((fooditem, i) => {
                  return (
                    <div style={foodItemStyle} className="newshadow">
                      <div style={containerfoodItemStyle}>
                      {fooditem.config.isUsingImage === true && this.props.item.switchDiamondbackground == false &&
                          <ImageFoodGroup
                            ImageUploaded={this.props.item.headerImage}
                            foodItemTemplate={fooditem}
                            foodItemImage={fooditem.template.picto}
                            id_foodgroup={this.props.item.id}
                            color_accent={this.props.item.colorAccent}
                          />}
                        <div
                          style={
                            fooditem.config && fooditem.config.isUsingImage === false
                              ? bodyStyleNi
                              : bodyStyle
                          }
                        >
                          <div style={overflowStyle}>
                            <div className="containerCardFg">
                              {!fooditem.tags
                                ? null
                                : fooditem.tags
                                  .filter(function (value) {
                                    return value.tag.kind === "ORIGIN";
                                  })
                                  .map(function (tag, i) {
                                    return (
                                      <h4
                                        style={originStyle}
                                        className="itemCardFg"
                                      >
                                        <FontAwesomeIcon
                                          icon={faMapMarker}
                                          className="mr-2"
                                        />
                                        {tag.tag.name}
                                      </h4>
                                    );
                                  })}

                              {!fooditem.name ? null : (
                                <h3
                                  className="itemCardFg75"
                                  style={
                                    fooditem.config.isUsingImage === false
                                      ? titleNIStyle
                                      : titleStyle
                                  }
                                >
                                  {fooditem.name}
                                </h3>
                              )}
                              {!fooditem.name_secondary ? null : (
                                <h3
                                  className="itemCardFg"
                                  style={
                                    fooditem.config.isUsingImage === false
                                      ? titleSecNIStyle
                                      : titleSecStyle
                                  }
                                >
                                  {fooditem.name_secondary}
                                </h3>
                              )}
                              {!fooditem.description ? null : (
                                <h3
                                  className="itemCardFg"
                                  style={
                                    fooditem.config.isUsingImage === false
                                      ? descriptionNIStyle
                                      : descriptionStyle
                                  }
                                >
                                  {fooditem.description}
                                </h3>
                              )}
                              {!fooditem.description_secondary ? null : (
                                <h3
                                  className="itemCardFg"
                                  style={
                                    fooditem.config.isUsingImage === false
                                      ? descriptionSecNIStyle
                                      : descriptionSecStyle
                                  }
                                >
                                  {fooditem.description_secondary}
                                </h3>
                              )}
                              {!fooditem.calories ? null : (
                                <h4
                                  className="itemCardFg"
                                  style={caloriesStyle}
                                >
                                  Calories: {fooditem.calories} kcal
                                </h4>
                              )}

                              {!fooditem.tags ? null : (
                                <div
                                  className="itemCardFg"
                                  style={allergyContStyle}
                                >
                                  {fooditem.tags
                                    .filter(function (value) {
                                      return value.tag.kind === "ALLERGEN";
                                    })
                                    .map((item) => {
                                      return (
                                        <h3 style={allergyIconStyle}>
                                          {this.getIconSvg(item.tag.name)}
                                        </h3>
                                      );
                                    })}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div style={containerLabelStyle}>
                        {!fooditem.tags
                          ? null
                          : fooditem.tags
                            .filter(function (value) {
                              return value.tag.kind === "LABEL";
                            })
                            .slice(0, 3)
                            .map(function (tag, i) {
                              return (
                                <Image
                                  className="newshadow"
                                  src={tag.tag.image}
                                  style={tagImageStyle_AGR}
                                />
                              );
                            })}
                      </div>

                      {fooditem.prices === null ? null : (
                        fooditem.prices[0].value === 0 || fooditem.prices[0].value === null ? null : (
                          <div
                          style={this.props.item.switchDiamondbackground === false ? containerPricesStyle : containerPricesStyle_agr}
                          className={this.props.item.switchDiamondbackground === false ? "newshadow" : "octa"

                          } 
                          >
                          <h3 style={this.props.item.switchDiamondbackground === false ? pricesStyle : pricesStyle_AGR}>
                              {this.GetPriceAdjustment(fooditem.prices[0].value,fooditem.prices[0].currency)}
                              </h3>
                              <h6 style={this.props.item.switchDiamondbackground === false ? pricesStyle : pricesStyle_AGR_h6(fooditem.prices[0].currency)}>
                              {this.props.item.switchDiamondbackground === true && fooditem.prices[0].currency === "PTS" ? fooditem.prices[0].currency="Points":""
                              }
                              {fooditem.prices[0].currency === " " ||
                                fooditem.prices[0].currency === "" ||
                                fooditem.prices[0].currency === "EUR" ||
                                fooditem.prices[0].currency === "Eur" ||
                                fooditem.prices[0].currency === "eur" ||
                                fooditem.prices[0].currency === "Euro"
                                ? "€"
                                : this.capitalize(
                                  fooditem.prices[0].currency
                                )}
                            </h6>
                          </div>
                        )
                      )}
                    </div>
                  );
                })}
          </div>
        </div>
      </>
    );
  }
}

export default FoodGroup_Port;
